<template>
  <div class="default" :class="[color]"></div>
</template>

<script>
export const LineColor = Object.freeze({
  brand: 'brand',
  gray: 'gray',
  gray2: 'gray-2',
  gray3: 'gray-3',
  black: 'black',
  white: 'white',
  disable: 'disable',
  inactive: 'inactive',
  warning: 'warning',
  emergency: 'emergency'
})

export default {
  name: 'VHR',
  props: {
    weight: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: LineColor.gray
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.default {
  border: none;
  // height: 1px;
  width: 100%;
}

.brand {
  border-top: 1px solid $brand;
}

.gray {
  border-top: 1px solid $light-gray-3;
}

.gray-2 {
  border-top: 1px solid $light-gray-8;
}

.gray-3 {
  border-top: 1px solid $light-gray-5;
}

.black {
  border-top: 1px solid $black;
}

.white {
  border-top: 1px solid $white;
}

.disable {
  border-top: 1px solid $light-gray-3;
}

.inactive {
  border-top: 1px solid $light-gray;
}

.warning {
  border-top: 1px solid $orange;
}

.emergency {
  border-top: 1px solid $red;
}
</style>